import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0"
}
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "profile-info d-sm-flex align-items-center" }
const _hoisted_4 = { class: "title m-0" }
const _hoisted_5 = { class: "text-black fw-medium mb-8" }
const _hoisted_6 = { class: "d-block text-dark-emphasis mb-0 small" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_9 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pencil text-black position-relative top-1 fs-16 me-1" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "info mt-25 ps-0 mb-0 list-unstyled" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-success rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-envelope-simple" })
], -1 /* HOISTED */)
const _hoisted_14 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 0,
  class: "position-relative"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-warning-light rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ph ph-phone" })
], -1 /* HOISTED */)
const _hoisted_18 = { class: "d-block text-black mb-5 fw-semibold" }
const _hoisted_19 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.info)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.info.firstname) + " " + _toDisplayString(_ctx.info.lastname), 1 /* TEXT */),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.info.id), 1 /* TEXT */)
            ])
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h5", _hoisted_9, _toDisplayString(_ctx.$t('form.section.personal_information')), 1 /* TEXT */),
            (_ctx.update_password_enabled)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  to: "profile/update-password",
                  class: "d-inline-block text-decoration-none lh-1 text-muted fw-medium"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('cta.update_password')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("ul", _hoisted_11, [
            _createElementVNode("li", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
              _createElementVNode("a", {
                href: `mailto:${_ctx.info.email}`,
                class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
              }, _toDisplayString(_ctx.info.email), 9 /* TEXT, PROPS */, _hoisted_15)
            ]),
            (_ctx.info.invitation_id == null)
              ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('form.phone.label')), 1 /* TEXT */),
                  _createElementVNode("a", {
                    href: `tel:${_ctx.info.phone_number}`,
                    class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none"
                  }, _toDisplayString(_ctx.info.phone_number), 9 /* TEXT, PROPS */, _hoisted_19)
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createCommentVNode(" RIGHT TO ERASURE ")
        ])
      ]))
    : _createCommentVNode("v-if", true)
}